module.exports = __webpack_public_path__ + "static/img/course-tip-bg.bd5a1ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/course-tip-bg.png
// module id = fR2j
// module chunks = 1